import { render, staticRenderFns } from "./SupplyingOfLots.vue?vue&type=template&id=3f9fc248"
import script from "./SupplyingOfLots.vue?vue&type=script&lang=js"
export * from "./SupplyingOfLots.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports